import { forwardRef } from "react";

import { TitleStyled } from "./Title.styles";
import { TTitleProps, TTitleRef } from "./Title.types";

const Title = forwardRef<TTitleRef, TTitleProps>(function Title({ weight = "base", variant = "base", textAlign, isMarginless, ...rest }, ref) {
  return (
    <TitleStyled
      ref={ref}
      $weight={weight}
      $variant={variant}
      $textAlign={textAlign}
      $isMarginless={isMarginless}
      {...rest}
    />
  );
});

export default Title;
